import React, { Component } from 'react';
import axios from '../request';
import moment from 'moment';

moment.locale('el');

class BookOddsDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookOdds: null
    };
  }

  componentDidMount() {
    let DATE = moment.unix(this.props.date).format('YYYY-MM-DD');
    let FID = this.props.fid;
    const _this = this;

    axios
      .get(`/v2/kouponi/odds/${ DATE }/${ FID }`)
      .then((response) => {
        _this.setState({
          bookOdds: response.data
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //      <tr key={o}>
  //        <td className="divider book_name" style={{backgroundColor: this.state.bookOdds[o].bg_color}}>
  //        {/*<a target="_blank" href={this.state.bookOdds[o].aff_link}>{_.capitalize(o)}</a>*/}
  //          <a target="_blank" href={this.state.bookOdds[o].aff_link}>
  //            <img src={this.state.bookOdds[o].image_url} />
  //          </a>
  //        </td>
  //        <td><a target="_blank" href={this.state.bookOdds[o].aff_link}>{parseFloat( this.state.bookOdds[o].odd_1, 10).toFixed(2)}</a></td>
  //        <td><a target="_blank" href={this.state.bookOdds[o].aff_link}>{parseFloat( this.state.bookOdds[o].odd_X, 10).toFixed(2)}</a></td>
  //        <td className="divider"><a target="_blank" href={this.state.bookOdds[o].aff_link}>{parseFloat( this.state.bookOdds[o].odd_2, 10).toFixed(2)}</a></td>
  //        <td><a target="_blank" href={this.state.bookOdds[o].aff_link}>{parseFloat( this.state.bookOdds[o].odd_u25, 10).toFixed(2)}</a></td>
  //        <td><a target="_blank" href={this.state.bookOdds[o].aff_link}>{parseFloat( this.state.bookOdds[o].odd_o25, 10).toFixed(2)}</a></td>
  //      </tr>

  render() {
    if (this.state.bookOdds === null) {
      return (
        <div className="odds_loader">
          <span className="block-loader">
            <svg className="circle-loader progress" width="22" height="22" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="8"/>
            </svg>
          </span>
        </div>
      );
    }

    if (this.state.bookOdds === false) {
      return null;
    }


    const ROWS = [];
    for (let o in this.state.bookOdds) {
      if (this.state.bookOdds.hasOwnProperty(o)) {

        ROWS.push(
          <tr key={ o }>
            <td className="divider book_name" style={ {backgroundColor: this.state.bookOdds[o].bg_color} }>
              {/*<a target="_blank" href={this.state.bookOdds[o].aff_link}>{_.capitalize(o)}</a>*/ }
              <a target="_blank" href={ this.state.bookOdds[o].aff_link }>
                <img src={ this.state.bookOdds[o].image_url } alt=""/>
              </a>
            </td>
            <td><a>{ parseFloat(this.state.bookOdds[o].odd_1, 10).toFixed(2) }</a></td>
            <td><a>{ parseFloat(this.state.bookOdds[o].odd_X, 10).toFixed(2) }</a></td>
            <td className="divider"><a>{ parseFloat(this.state.bookOdds[o].odd_2, 10).toFixed(2) }</a></td>
            <td><a>{ parseFloat(this.state.bookOdds[o].odd_u25, 10).toFixed(2) }</a></td>
            <td><a>{ parseFloat(this.state.bookOdds[o].odd_o25, 10).toFixed(2) }</a></td>
          </tr>
        );
      }

    }

    // Dont echo anything is no odds retured
    if (!ROWS.length) return null;

    return (
      <div>
        <div className="header">
          <span>ΑΠΟΔΟΣΕΙΣ ΝΟΜΙΜΩΝ ΣΤΟΙΧΗΜΑΤΙΚΩΝ</span>
        </div>

        <table>
          <thead>
          <tr>
            <th rowSpan="2" className="divider">ΣΤΟΙΧΗΜΑΤΙΚΕΣ</th>
            <th colSpan="3" className="divider">ΤΕΛΙΚΟ<br/>ΑΠΟΤΕΛΕΣΜΑ</th>
            <th colSpan="2">UNDER / OVER <br/> 2.5 GOALS</th>
          </tr>
          <tr>
            {/*tel*/ }
            <th className="em">1</th>
            <th className="em">Χ</th>
            <th className="em divider">2</th>
            {/*ht*/ }
            <th className="em">U</th>
            <th className="em divider">O</th>
          </tr>
          </thead>
          <tbody>
          { ROWS }
          </tbody>
        </table>
      </div>
    )
  }

};

export default BookOddsDropdown;



// WEBPACK FOOTER //
// ./src/Components/BookOddsDropdown.js